import { render, staticRenderFns } from "./OtherRegister.vue?vue&type=template&id=751735fd&scoped=true"
import script from "./OtherRegister.vue?vue&type=script&lang=js"
export * from "./OtherRegister.vue?vue&type=script&lang=js"
import style0 from "./OtherRegister.vue?vue&type=style&index=0&id=751735fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751735fd",
  null
  
)

export default component.exports